import React, { useState } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { DstYearUpdate } from "./dstYearUpdate";
import { AddNew } from "../../uiControls/addNew";

const dstYearColumns = [
  {
    label: "Year",
    keyField: "yearKey",
    dataField: "year",
    dataType: "string",
  },
  {
    label: "Start Date",
    keyField: "yearKey",
    dataField: "startDate",
    dataType: "date",
  },
  {
    label: "End Date",
    keyField: "yearKey",
    dataField: "endDate",
    dataType: "date",
  },
  {
    label: "",
    keyField: "yearKey",
    dataField: "yearKey",
    dataType: "number",
    minWidth: 20,
    maxWidth: 20,
  },
];

const dstYearSearchColumns = ["year", "startDate", "endDate"];

export const DstYearConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [dstYearEdit, setDstYearEdit] = useState(null);
  const [dstYearAttributes, setDstYearAttributes] = useState({
    yearKey: 0,
    year: 0,
    startDate: "",
    endDate: "",
  });

  const { sendRequest: fetchDstYearDetails } = useHttpRequests();

  const dstYearEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getDstYearDetails = (dstYearObj) => {
      if (!dstYearObj || !dstYearObj.isSuccess || dstYearObj.errorResponse) {
        console.log("DstYear fetch response returns error");
        return;
      }

      setDstYearAttributes({
        yearKey: dstYearObj["dstYear"]["yearKey"],
        year: dstYearObj["dstYear"]["year"],
        startDate: dstYearObj["dstYear"]["startDate"],
        endDate: dstYearObj["dstYear"]["endDate"],
      });

      setDstYearEdit(true);
      setUpdateOpen(true);
    };

    fetchDstYearDetails(
      { url: "DstYears/" + key, method: "GET", header: true },
      getDstYearDetails
    );
  };

  const getUrl = (params) => {
    return "DstYears";
  };

  const dstYearDetailProps = {
    setUpdateOpen,
    dstYearEdit,
    setDstYearEdit,
    dstYearAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={dstYearColumns}
              url={getUrl}
              sourceObj="dstYears"
              editHandler={dstYearEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={dstYearSearchColumns}
              changeStatus={() => {}}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setDstYearAttributes({
                  yearKey: 0,
                  year: 0,
                  startDate: "",
                  endDate: "",
                });
                setDstYearEdit(false);
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: window.innerWidth <= 1366 ? "100%" : "65%",
          }}
        >
          <DstYearUpdate {...dstYearDetailProps} />
        </div>
      )}
    </div>
  );
};
